import { type ContentObjectList, type NonEventContentObjectDetail, isNodeEventContentObject } from 'models';
import { useUser } from 'features/auth';
import { BasicStatusBar } from './basic-status-bar';
import { GroupStatusBar } from './group-status-bar';
import { ProgramStatusBar } from './program-status-bar';

type P = {
  item: ContentObjectList | NonEventContentObjectDetail;
  onShowComments?: () => void;
};

const StatusBar = ({ item, onShowComments }: P) => {
  const user = useUser({ requiredAuth: false });

  if (!user) {
    return null;
  }

  if (isNodeEventContentObject(item)) {
    return <BasicStatusBar item={item} onShowComments={onShowComments} />;
  }

  switch (item.contentableType) {
    case 'Community':
    case 'Organization':
      return <BasicStatusBar item={item} onShowComments={onShowComments} />;
    case 'Group':
      return <GroupStatusBar item={item} />;
    case 'Program':
      return <ProgramStatusBar item={item} onShowComments={onShowComments} />;
    case undefined:
      return null;
    default:
      return null;
  }
};
export default StatusBar;
